export default __webpack_public_path__ + "static/15-37a268736e2a7f119c9e3752a378179c.jpg";